<div id="main-wrapper">
    <div class="site-wrapper-reveal">
        <div class="position-relative w-100">
            <div class="d-flex align-items-center w-100">

                <!-- "> md" -->
                <img src="../../../assets/images/banners/desktop-enter.png"
                    class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="desktop enter" />

                <!-- "<= md" -->
                <img src="../../../assets/images/banners/entertaimnemnt-mobile.png"
                    class="img img-responsive d-block d-md-none" width="100%" alt="entertainment mobile" />

                <!-- <img src="../../../assets/images/banners/mitbannername.png"
                    alt="Banner-mit" class="img-responsive w-100 h-100"> -->
                <div class="position-absolute w-100 home-banner">
                    <div class="row h-100 w-100">
                        <div class="col-8 col-md-4 col-sm-6 banner-section">
                            <div class="align-items-center banner-content-title  global_title global_banner_title"
                                role="heading" aria-level="1">
                                <span>Media and Entertainment</span>
                            </div>
                            <div class="global_sub_title global_banner_subtitle mt-3" role="heading" aria-level="1">
                                <span>Achieve a competitive edge with our industry-driven Services. </span>
                            </div>
                            <div class="col pt-lg-5 pt-3 mt-lg-3">


                                <a href="contact" class="global_button  text-left col  text-white white_button"
                                    role="button" aria-label="View Contact Page" tabindex="0">
                                    <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png"
                                            alt="arrow white" /></div>
                                    TALK TO OUR EXPERT
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class=" banner-subsection col">
         <h5>Trusted by Global Technology companies</h5>
         </div> -->
    </div>
</div>




<div class="laptop_bg_image">
    <div class="container pt-5">
        <div class="row">
            <div class="col-lg-12 col-sm-12">
                <div class="mobile_content_service global_section_header pt-5">

                    Bring digital revolution to media & entertainment industry with IT processes
                </div>
                <div class="mobile_service-subcontent global_section_content pt-5">

                    <p>The media & entertainment sector is undergoing a major IT transformation helping reach a vast
                        audience worldwide. However, there are also significant hurdles that’s inhibiting the industry
                        to reach its maximum potential. The main ones include the constant modification of search engine
                        algorithms, the dissemination of content, the decline in readership, and the creation of new
                        revenue streams. But as technology has advanced, new options for material distribution and
                        management have become available. </p>

                    <p>

                        Maganti IT wants to aid the media and entertainment sector in keeping up with the digital
                        change, develop a distinctive brand voice, improve user experiences across platforms, and
                        increase conversions. You may monitor and analyse readership statistics, streamline content
                        development and management, and achieve the necessary business goals with the help of our
                        innovation-driven solutions. </p>
                </div>
            </div>
        </div>
    </div>
</div>



<!--------------- SERVICE OFFERINGS STARTS HERE ------->
<div class="feature-images-wrapper  section-space--ptb_80">
    <div class="container">

        <div class="row">
            <div class="col-lg-12">
                <!-- section-title-wrap Start -->
                <div class="section-title-wrap text-center section-space--mb_30" role="heading" aria-level="1">
                    <div class="finance-heading mat-h3 fw-bold">Entertainment & Media Consulting </div>
                    <p class="global_sub_title vision-content-section pt-2">Discover new ways to engage with today's
                        digital clients
                        and use cutting-edge technology skills to enhance your company </p>
                </div>
                <!-- section-title-wrap Start -->
            </div>
        </div>

        <div class="feature-images__four">
            <div class=" row">
                <div class="single-item col-lg-4 col-md-6 mt-30 wow move-up">
                    <!-- ht-box-icon Start -->
                    <a (click)="scrollToSection('main-wrapper')" class="ht-box-images style-04" role="button">
                        <div class="image-box-wrap">
                            <div class="box-image">
                                <img class="img-fulid" src="../../../assets/images/entertainment/mobileapp.png"
                                    alt="entertainment mobileapp">
                            </div>
                            <div class="content">
                                <div class="what-heading sixthheading text-dark">Global section content Mobile Apps and
                                    web developement </div>
                                <div class="text global_section_content pt-2">Stay connected to the global audience by
                                    leveraging our website and
                                    mobile app development services and solutions. </div>
                            </div>
                        </div>
                    </a>
                    <!-- ht-box-icon End -->
                </div>
                <div class="single-item col-lg-4 col-md-6 mt-30 wow move-up">
                    <!-- ht-box-icon Start -->
                    <a (click)="scrollToSection('main-wrapper')" class="ht-box-images style-04" role="button">
                        <div class="image-box-wrap">
                            <div class="box-image">
                                <img class="img-fulid" src="../../../assets/images/entertainment/digital.png"
                                    alt="entertainment digital">
                            </div>
                            <div class="content">
                                <div class="what-heading sixthheading text-dark">Digital Advertising </div>
                                <div class="text global_section_content pt-2">Digital marketing services that are
                                    simplified can help you expand the
                                    reach of your business and get the most out of your content strategy. </div>
                            </div>
                        </div>
                    </a>
                    <!-- ht-box-icon End -->
                </div>
                <div class="single-item col-lg-4 col-md-6 mt-30 wow move-up">
                    <!-- ht-box-icon Start -->
                    <a (click)="scrollToSection('main-wrapper')" class="ht-box-images style-04" role="button">
                        <div class="image-box-wrap">
                            <div class="box-image">
                                <img class="img-fulid" src="../../../assets/images/entertainment/engineering.png"
                                    alt="entertainment enginering">
                            </div>
                            <div class="content">
                                <div class="what-heading sixthheading text-dark">Digital Engineering </div>
                                <div class="text global_section_content pt-2">We combine our client-centric methodology
                                    with our knowledge of
                                    digital engineering to drive swift innovation and support your rapid and effective
                                    scaling. </div>
                            </div>
                        </div>
                    </a>
                    <!-- ht-box-icon End -->
                </div>
                <div class="single-item col-lg-4 col-md-6 mt-30 wow move-up">
                    <!-- ht-box-icon Start -->
                    <a (click)="scrollToSection('main-wrapper')" class="ht-box-images style-04" role="button">
                        <div class="image-box-wrap">
                            <div class="box-image">
                                <img class="img-fulid" src="../../../assets/images/entertainment/crm.png"
                                    alt="entertainment crm">
                            </div>
                            <div class="content">
                                <div class="what-heading sixthheading text-dark">CRM/ERP Products </div>
                                <div class="text global_section_content pt-2">You can create content, deliver it, manage
                                    it, manage projects, and
                                    more with the help of our CRM and ERP technologies. </div>
                            </div>
                        </div>
                    </a>
                    <!-- ht-box-icon End -->
                </div>
                <div class="single-item col-lg-4 col-md-6 mt-30 wow move-up">
                    <!-- ht-box-icon Start -->
                    <a (click)="scrollToSection('main-wrapper')" class="ht-box-images style-04" role="button">
                        <div class="image-box-wrap">
                            <div class="box-image">
                                <img class="img-fulid" src="../../../assets/images/entertainment/it.png"
                                    alt="entertainment information">
                            </div>
                            <div class="content">
                                <div class="what-heading sixthheading text-dark">Managed IT Services </div>
                                <div class="text global_section_content pt-2">Optimize and quickly scale your services
                                    without downtime- helping you
                                    achieve business goals while leveraging the power, scalability, and flexibility of
                                    the cloud. </div>
                            </div>
                        </div>
                    </a>
                    <!-- ht-box-icon End -->
                </div>
                <div class="single-item col-lg-4 col-md-6 mt-30 wow move-up">
                    <!-- ht-box-icon Start -->
                    <a (click)="scrollToSection('main-wrapper')" class="ht-box-images style-04" role="button">
                        <div class="image-box-wrap">
                            <div class="box-image">
                                <img class="img-fulid" src="../../../assets/images/entertainment/event.png"
                                    alt="entertainment event">
                            </div>
                            <div class="content">
                                <div class="what-heading sixthheading text-dark">All-in-one Event Management </div>
                                <div class="text global_section_content pt-2 ">Full-fledged solutions for event budget
                                    management, secure event
                                    payment processing and event processing. </div>
                            </div>
                        </div>
                    </a>
                    <!-- ht-box-icon End -->
                </div>
            </div>
        </div>
    </div>
</div>
<!--======== Ourcompany tabs starts ======== -->








<!---------------  BENEFITS THAT MATTER ENDS HERE ------->

<div class="feature-large-images-wrapper section-space--pt_60">
    <div class="container">

        <div class="row">
            <div class="col-lg-12">
                <!-- section-title-wrap Start -->
                <div class="section-title-wrap text-center section-space--mb_30">
                    <div class="section-sub-title mb-20 mat-h3 fw-bold" >Case Studies</div>

                </div>
                <!-- section-title-wrap Start -->
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="row row--35">

                    <div class="col-lg-4 col-md-6 mt-30">
                        <!-- Box large image warap Start -->
                        <a href="/futek-casestudy" class="box-large-image__wrap wow move-up"
                            aria-label="Go to futek casestudy">
                            <div class="box-large-image__box">
                                <div class="box-large-image__midea">
                                    <div class="images-midea">
                                        <img src="../../../assets/images/manufacture/Futek.png" width="330" height="330"
                                            alt="manufacture futek">

                                        <div class="button-wrapper">
                                            <div class="btn tm-button">
                                                <span class="industries_button-text">Learn more</span>
                                            </div>
                                        </div>
                                        <div class="heading-wrap">
                                            <div class="heading mat-h4 fw-bold">FUTEK</div>
                                        </div>
                                    </div>
                                </div>

                                <div class=" global_section_content mt-30 ">
                                    <p>
                                        FUTEK, a leading sensor technology giant
                                        takes the leap to cloud for a major IT
                                        transformation and innovation.
                                    </p>
                                </div>
                            </div>
                        </a>
                        <!-- Box large image warap End -->
                    </div>

                    <div class="col-lg-4 col-md-6  mt-30">
                        <!-- Box large image warap Start -->
                        <a href="/ouropinion-casestudy" class="box-large-image__wrap wow move-up"
                            aria-label="Read Ouropinion Casestudy">
                            <div class="box-large-image__box">
                                <div class="box-large-image__midea">
                                    <div class="images-midea">
                                        <img src="../../../assets/images/manufacture/manufacture-ouropinion.png"
                                            width="330" height="330" alt="manufacture ourpoinion">


                                        <div class="button-wrapper">
                                            <div class="btn tm-button">
                                                <span class="industries_button-text">Learn more</span>
                                            </div>
                                        </div>
                                        <div class="heading-wrap">
                                            <div class="heading mat-h4 fw-bold">Our Opinions </div>
                                        </div>

                                    </div>
                                </div>

                                <div class=" global_section_content mt-30">
                                    <p>
                                        Learn how we built a futuristic application
                                        and incorporated future cloud advances into
                                        our client’s IT infrastructure.

                                    </p>
                                </div>
                            </div>
                        </a>
                        <!-- Box large image warap End -->
                    </div>


                    <div class="col-lg-4 col-md-6  mt-30">
                        <!-- Box large image warap Start -->
                        <a href="/curorc" class="box-large-image__wrap wow move-up"
                            aria-label="Learn more about curorc">
                            <div class="box-large-image__box">
                                <div class="box-large-image__midea">
                                    <div class="images-midea">
                                        <img src="../../../assets/images/manufacture/curorc.png" width="330"
                                            height="330" alt="manufacture curorc">


                                        <div class="button-wrapper">
                                            <div class="btn tm-button">
                                                <span class="industries_button-text">Learn more</span>
                                            </div>
                                        </div>
                                        <div class="heading-wrap">
                                            <div class="heading mat-h4 fw-bold">CuroRc</div>
                                        </div>

                                    </div>
                                </div>

                                <div class=" global_section_content mt-30">
                                    <p>Our technical experts have a flair for developing clean-coded
                                        websites based on customers’ needs, global guidelines and trends.
                                    </p>
                                </div>
                            </div>
                        </a>
                        <!-- Box large image warap End -->
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>
<br>